// 30 Rich Goal Templates - Covering All Aspects of Life

export const GOAL_TEMPLATES = [
  // RELATIONSHIP & FAMILY (6)
  {
    id: 'engaged',
    title: 'Get Engaged',
    lucideIcon: 'Gem',
    image: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?w=400&h=300&fit=crop',
    category: 'relationship',
    estimatedCost: 5000,
    duration: '1-3 months',
    description: 'Pop the question and start your journey to forever together',
    color: 'bg-gradient-to-br from-rose-400 to-pink-600',
    tasks: [
      { id: 1, title: 'Choose engagement ring', completed: false, aiGenerated: false },
      { id: 2, title: 'Plan proposal location and moment', completed: false, aiGenerated: false },
      { id: 3, title: 'Celebrate with family and friends', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'wedding',
    title: 'Plan Dream Wedding',
    lucideIcon: 'Heart',
    image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=400&h=300&fit=crop',
    category: 'relationship',
    estimatedCost: 25000,
    duration: '12-18 months',
    description: 'Create the wedding celebration of your dreams',
    color: 'bg-gradient-to-br from-pink-400 to-rose-600',
    tasks: [
      { id: 1, title: 'Set wedding budget', completed: false, aiGenerated: false },
      { id: 2, title: 'Choose wedding date and venue', completed: false, aiGenerated: false },
      { id: 3, title: 'Book vendors and send invitations', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'baby',
    title: 'Start a Family',
    lucideIcon: 'Baby',
    image: 'https://images.unsplash.com/photo-1555252333-9f8e92e65df9?w=400&h=300&fit=crop',
    category: 'relationship',
    estimatedCost: 15000,
    duration: '12-18 months',
    description: 'Prepare for the beautiful journey of parenthood',
    color: 'bg-gradient-to-br from-amber-300 to-orange-500',
    tasks: [
      { id: 1, title: 'Prepare nursery and essentials', completed: false, aiGenerated: false },
      { id: 2, title: 'Review health insurance and finances', completed: false, aiGenerated: false },
      { id: 3, title: 'Take parenting and birthing classes', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'anniversary',
    title: 'Plan Anniversary Trip',
    lucideIcon: 'Plane',
    image: 'https://images.unsplash.com/photo-1530789253388-582c481c54b0?w=400&h=300&fit=crop',
    category: 'relationship',
    estimatedCost: 5000,
    duration: '2-4 months',
    description: 'Celebrate your love with an unforgettable getaway',
    color: 'bg-gradient-to-br from-red-400 to-pink-600',
    tasks: [
      { id: 1, title: 'Choose romantic destination', completed: false, aiGenerated: false },
      { id: 2, title: 'Book accommodations and experiences', completed: false, aiGenerated: false },
      { id: 3, title: 'Plan special surprises', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'vow-renewal',
    title: 'Renew Wedding Vows',
    lucideIcon: 'HeartHandshake',
    image: 'https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=400&h=300&fit=crop',
    category: 'relationship',
    estimatedCost: 8000,
    duration: '3-6 months',
    description: 'Reaffirm your commitment with a meaningful ceremony',
    color: 'bg-gradient-to-br from-purple-400 to-pink-500',
    tasks: [
      { id: 1, title: 'Choose venue and date', completed: false, aiGenerated: false },
      { id: 2, title: 'Write personal vows', completed: false, aiGenerated: false },
      { id: 3, title: 'Plan celebration with loved ones', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'date-nights',
    title: 'Monthly Date Nights',
    lucideIcon: 'Wine',
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=300&fit=crop',
    category: 'relationship',
    estimatedCost: 2400,
    duration: '12 months',
    description: 'Commit to regular quality time and romance',
    color: 'bg-gradient-to-br from-fuchsia-400 to-purple-600',
    tasks: [
      { id: 1, title: 'Create date night budget', completed: false, aiGenerated: false },
      { id: 2, title: 'Plan 12 unique experiences', completed: false, aiGenerated: false },
      { id: 3, title: 'Schedule dates in calendar', completed: false, aiGenerated: false }
    ]
  },

  // HOME & LIVING (5)
  {
    id: 'first-home',
    title: 'Buy First Home',
    lucideIcon: 'Home',
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=400&h=300&fit=crop',
    category: 'home',
    estimatedCost: 50000,
    duration: '12-24 months',
    description: 'Achieve the dream of homeownership',
    color: 'bg-gradient-to-br from-blue-400 to-indigo-600',
    tasks: [
      { id: 1, title: 'Save for down payment', completed: false, aiGenerated: false },
      { id: 2, title: 'Get pre-approved for mortgage', completed: false, aiGenerated: false },
      { id: 3, title: 'Find and close on dream home', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'renovation',
    title: 'Home Renovation',
    lucideIcon: 'Hammer',
    image: 'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=400&h=300&fit=crop',
    category: 'home',
    estimatedCost: 30000,
    duration: '3-9 months',
    description: 'Transform your space into your dream home',
    color: 'bg-gradient-to-br from-slate-400 to-zinc-600',
    tasks: [
      { id: 1, title: 'Plan renovation scope and budget', completed: false, aiGenerated: false },
      { id: 2, title: 'Hire contractors and get permits', completed: false, aiGenerated: false },
      { id: 3, title: 'Complete renovation and final touches', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'move-in',
    title: 'Move In Together',
    lucideIcon: 'PackageOpen',
    image: 'https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=400&h=300&fit=crop',
    category: 'home',
    estimatedCost: 5000,
    duration: '1-3 months',
    description: 'Take the exciting step of sharing a home',
    color: 'bg-gradient-to-br from-teal-400 to-cyan-600',
    tasks: [
      { id: 1, title: 'Find the perfect place', completed: false, aiGenerated: false },
      { id: 2, title: 'Merge belongings and declutter', completed: false, aiGenerated: false },
      { id: 3, title: 'Set up your shared space', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'pet',
    title: 'Adopt a Pet',
    lucideIcon: 'PawPrint',
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400&h=300&fit=crop',
    category: 'home',
    estimatedCost: 2000,
    duration: '1-2 months',
    description: 'Welcome a furry family member into your home',
    color: 'bg-gradient-to-br from-amber-400 to-yellow-600',
    tasks: [
      { id: 1, title: 'Research breeds and needs', completed: false, aiGenerated: false },
      { id: 2, title: 'Prepare home and supplies', completed: false, aiGenerated: false },
      { id: 3, title: 'Adopt and schedule vet visit', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'garden',
    title: 'Create Dream Garden',
    lucideIcon: 'Flower2',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=300&fit=crop',
    category: 'home',
    estimatedCost: 3000,
    duration: '3-6 months',
    description: 'Design and cultivate your perfect outdoor space',
    color: 'bg-gradient-to-br from-green-400 to-emerald-600',
    tasks: [
      { id: 1, title: 'Plan garden layout and design', completed: false, aiGenerated: false },
      { id: 2, title: 'Prepare soil and purchase plants', completed: false, aiGenerated: false },
      { id: 3, title: 'Plant and establish maintenance routine', completed: false, aiGenerated: false }
    ]
  },

  // CAREER & FINANCE (5)
  {
    id: 'promotion',
    title: 'Get Promoted',
    lucideIcon: 'TrendingUp',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400&h=300&fit=crop',
    category: 'career',
    estimatedCost: 500,
    duration: '6-12 months',
    description: 'Advance your career to the next level',
    color: 'bg-gradient-to-br from-emerald-400 to-green-600',
    tasks: [
      { id: 1, title: 'Document achievements and impact', completed: false, aiGenerated: false },
      { id: 2, title: 'Develop new skills and take on leadership', completed: false, aiGenerated: false },
      { id: 3, title: 'Have promotion conversation with manager', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'side-business',
    title: 'Start Side Business',
    lucideIcon: 'Briefcase',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
    category: 'career',
    estimatedCost: 5000,
    duration: '3-6 months',
    description: 'Launch your entrepreneurial venture',
    color: 'bg-gradient-to-br from-violet-400 to-purple-600',
    tasks: [
      { id: 1, title: 'Validate business idea and market', completed: false, aiGenerated: false },
      { id: 2, title: 'Create business plan and brand', completed: false, aiGenerated: false },
      { id: 3, title: 'Launch and acquire first customers', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'emergency-fund',
    title: 'Build Emergency Fund',
    lucideIcon: 'Shield',
    image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=400&h=300&fit=crop',
    category: 'career',
    estimatedCost: 0,
    duration: '6-12 months',
    description: 'Create financial security with 6 months of savings',
    color: 'bg-gradient-to-br from-cyan-400 to-blue-600',
    tasks: [
      { id: 1, title: 'Calculate monthly expenses', completed: false, aiGenerated: false },
      { id: 2, title: 'Set up automatic savings transfers', completed: false, aiGenerated: false },
      { id: 3, title: 'Reach 6-month expense goal', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'debt-free',
    title: 'Become Debt Free',
    lucideIcon: 'Unlock',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop',
    category: 'career',
    estimatedCost: 0,
    duration: '12-36 months',
    description: 'Pay off all debt and achieve financial freedom',
    color: 'bg-gradient-to-br from-lime-400 to-green-600',
    tasks: [
      { id: 1, title: 'List all debts and create payoff plan', completed: false, aiGenerated: false },
      { id: 2, title: 'Implement debt snowball or avalanche method', completed: false, aiGenerated: false },
      { id: 3, title: 'Make final payment and celebrate', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'investment',
    title: 'Start Investing',
    lucideIcon: 'LineChart',
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=300&fit=crop',
    category: 'career',
    estimatedCost: 1000,
    duration: '1-3 months',
    description: 'Begin building long-term wealth through investments',
    color: 'bg-gradient-to-br from-yellow-400 to-orange-600',
    tasks: [
      { id: 1, title: 'Learn investment basics and strategies', completed: false, aiGenerated: false },
      { id: 2, title: 'Open brokerage account', completed: false, aiGenerated: false },
      { id: 3, title: 'Make first investment and set up recurring', completed: false, aiGenerated: false }
    ]
  },

  // HEALTH & WELLNESS (5)
  {
    id: 'marathon',
    title: 'Run a Marathon',
    lucideIcon: 'Timer',
    image: 'https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?w=400&h=300&fit=crop',
    category: 'health',
    estimatedCost: 500,
    duration: '6-12 months',
    description: 'Train for and complete 26.2 miles',
    color: 'bg-gradient-to-br from-orange-400 to-red-600',
    tasks: [
      { id: 1, title: 'Get running gear and start base training', completed: false, aiGenerated: false },
      { id: 2, title: 'Follow marathon training plan', completed: false, aiGenerated: false },
      { id: 3, title: 'Register and complete marathon', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'weight-loss',
    title: 'Lose Weight',
    lucideIcon: 'Scale',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop',
    category: 'health',
    estimatedCost: 200,
    duration: '3-12 months',
    description: 'Achieve your ideal healthy weight',
    color: 'bg-gradient-to-br from-pink-400 to-red-500',
    tasks: [
      { id: 1, title: 'Set realistic goal and timeline', completed: false, aiGenerated: false },
      { id: 2, title: 'Create nutrition and exercise plan', completed: false, aiGenerated: false },
      { id: 3, title: 'Track progress and reach goal weight', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'meditation',
    title: 'Daily Meditation Practice',
    lucideIcon: 'Sparkles',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&h=300&fit=crop',
    category: 'health',
    estimatedCost: 100,
    duration: '3 months',
    description: 'Build a consistent mindfulness habit',
    color: 'bg-gradient-to-br from-indigo-400 to-purple-600',
    tasks: [
      { id: 1, title: 'Choose meditation app or method', completed: false, aiGenerated: false },
      { id: 2, title: 'Start with 5 minutes daily', completed: false, aiGenerated: false },
      { id: 3, title: 'Build to 20+ minutes consistently', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'quit-smoking',
    title: 'Quit Smoking',
    lucideIcon: 'Ban',
    image: 'https://images.unsplash.com/photo-1555441293-6c6fb1eb9773?w=400&h=300&fit=crop',
    category: 'health',
    estimatedCost: 200,
    duration: '3-6 months',
    description: 'Break free from nicotine addiction',
    color: 'bg-gradient-to-br from-gray-400 to-slate-600',
    tasks: [
      { id: 1, title: 'Set quit date and tell support network', completed: false, aiGenerated: false },
      { id: 2, title: 'Get nicotine replacement or medication', completed: false, aiGenerated: false },
      { id: 3, title: 'Reach 6 months smoke-free', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'sleep',
    title: 'Improve Sleep Quality',
    lucideIcon: 'Moon',
    image: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=400&h=300&fit=crop',
    category: 'health',
    estimatedCost: 300,
    duration: '1-2 months',
    description: 'Get consistent, restful 8-hour sleep',
    color: 'bg-gradient-to-br from-blue-400 to-indigo-600',
    tasks: [
      { id: 1, title: 'Establish consistent sleep schedule', completed: false, aiGenerated: false },
      { id: 2, title: 'Optimize bedroom environment', completed: false, aiGenerated: false },
      { id: 3, title: 'Create relaxing bedtime routine', completed: false, aiGenerated: false }
    ]
  },

  // EDUCATION & SKILLS (4)
  {
    id: 'degree',
    title: 'Complete Degree',
    lucideIcon: 'GraduationCap',
    image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=400&h=300&fit=crop',
    category: 'education',
    estimatedCost: 20000,
    duration: '2-4 years',
    description: 'Earn your bachelors or masters degree',
    color: 'bg-gradient-to-br from-blue-500 to-indigo-700',
    tasks: [
      { id: 1, title: 'Research and apply to programs', completed: false, aiGenerated: false },
      { id: 2, title: 'Complete coursework and requirements', completed: false, aiGenerated: false },
      { id: 3, title: 'Graduate and celebrate', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'language',
    title: 'Learn New Language',
    lucideIcon: 'Languages',
    image: 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=400&h=300&fit=crop',
    category: 'education',
    estimatedCost: 500,
    duration: '12-24 months',
    description: 'Become conversational in a new language',
    color: 'bg-gradient-to-br from-teal-400 to-cyan-600',
    tasks: [
      { id: 1, title: 'Choose language and learning method', completed: false, aiGenerated: false },
      { id: 2, title: 'Practice daily for 30+ minutes', completed: false, aiGenerated: false },
      { id: 3, title: 'Have first real conversation with native speaker', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'certification',
    title: 'Get Professional Certification',
    lucideIcon: 'Award',
    image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400&h=300&fit=crop',
    category: 'education',
    estimatedCost: 2000,
    duration: '3-6 months',
    description: 'Earn an industry-recognized credential',
    color: 'bg-gradient-to-br from-amber-400 to-orange-600',
    tasks: [
      { id: 1, title: 'Research certifications in your field', completed: false, aiGenerated: false },
      { id: 2, title: 'Complete training and study materials', completed: false, aiGenerated: false },
      { id: 3, title: 'Pass certification exam', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'instrument',
    title: 'Learn Musical Instrument',
    lucideIcon: 'Music',
    image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400&h=300&fit=crop',
    category: 'education',
    estimatedCost: 1000,
    duration: '12-24 months',
    description: 'Master the basics of a musical instrument',
    color: 'bg-gradient-to-br from-rose-400 to-pink-600',
    tasks: [
      { id: 1, title: 'Choose instrument and get equipment', completed: false, aiGenerated: false },
      { id: 2, title: 'Take lessons or follow online course', completed: false, aiGenerated: false },
      { id: 3, title: 'Learn to play 10 songs confidently', completed: false, aiGenerated: false }
    ]
  },

  // TRAVEL & ADVENTURE (4)
  {
    id: 'world-trip',
    title: 'Travel the World',
    lucideIcon: 'Globe',
    image: 'https://images.unsplash.com/photo-1488085061387-422e29b40080?w=400&h=300&fit=crop',
    category: 'travel',
    estimatedCost: 15000,
    duration: '3-12 months',
    description: 'Experience different cultures and countries',
    color: 'bg-gradient-to-br from-sky-400 to-blue-600',
    tasks: [
      { id: 1, title: 'Create bucket list destinations', completed: false, aiGenerated: false },
      { id: 2, title: 'Plan itinerary and budget', completed: false, aiGenerated: false },
      { id: 3, title: 'Book flights and accommodations', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'road-trip',
    title: 'Epic Road Trip',
    lucideIcon: 'Car',
    image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=400&h=300&fit=crop',
    category: 'travel',
    estimatedCost: 3000,
    duration: '2-4 weeks',
    description: 'Hit the open road for an unforgettable journey',
    color: 'bg-gradient-to-br from-orange-400 to-amber-600',
    tasks: [
      { id: 1, title: 'Plan route and must-see stops', completed: false, aiGenerated: false },
      { id: 2, title: 'Prepare vehicle and pack essentials', completed: false, aiGenerated: false },
      { id: 3, title: 'Hit the road and document journey', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'hiking',
    title: 'Hike Famous Trail',
    lucideIcon: 'Mountain',
    image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=400&h=300&fit=crop',
    category: 'travel',
    estimatedCost: 2000,
    duration: '1-2 weeks',
    description: 'Conquer an iconic hiking trail',
    color: 'bg-gradient-to-br from-green-500 to-emerald-700',
    tasks: [
      { id: 1, title: 'Choose trail and get permits', completed: false, aiGenerated: false },
      { id: 2, title: 'Train and gather gear', completed: false, aiGenerated: false },
      { id: 3, title: 'Complete the hike', completed: false, aiGenerated: false }
    ]
  },
  {
    id: 'scuba',
    title: 'Learn Scuba Diving',
    lucideIcon: 'Waves',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400&h=300&fit=crop',
    category: 'travel',
    estimatedCost: 1500,
    duration: '1-2 months',
    description: 'Get certified and explore underwater worlds',
    color: 'bg-gradient-to-br from-cyan-400 to-teal-600',
    tasks: [
      { id: 1, title: 'Find PADI certified instructor', completed: false, aiGenerated: false },
      { id: 2, title: 'Complete classroom and pool training', completed: false, aiGenerated: false },
      { id: 3, title: 'Pass open water dives and get certified', completed: false, aiGenerated: false }
    ]
  }
];

// Category definitions with Lucide icons
export const GOAL_CATEGORIES = {
  relationship: {
    name: 'Relationship & Family',
    icon: '💕',
    lucideIcon: 'Heart',
    description: 'Love, family, and meaningful connections',
    color: 'bg-gradient-to-r from-rose-500 to-pink-600'
  },
  home: {
    name: 'Home & Living',
    icon: '🏠',
    lucideIcon: 'Home',
    description: 'Create your perfect living space',
    color: 'bg-gradient-to-r from-blue-500 to-indigo-600'
  },
  career: {
    name: 'Career & Finance',
    icon: '💼',
    lucideIcon: 'Briefcase',
    description: 'Professional growth and financial freedom',
    color: 'bg-gradient-to-r from-emerald-500 to-green-600'
  },
  health: {
    name: 'Health & Wellness',
    icon: '🏃',
    lucideIcon: 'HeartPulse',
    description: 'Physical and mental well-being',
    color: 'bg-gradient-to-r from-orange-500 to-red-600'
  },
  education: {
    name: 'Education & Skills',
    icon: '🎓',
    lucideIcon: 'GraduationCap',
    description: 'Learning and personal development',
    color: 'bg-gradient-to-r from-violet-500 to-purple-600'
  },
  travel: {
    name: 'Travel & Adventure',
    icon: '✈️',
    lucideIcon: 'Plane',
    description: 'Explore the world and create memories',
    color: 'bg-gradient-to-r from-sky-500 to-cyan-600'
  }
};

// Helper function to get templates by category
export const getTemplatesByCategory = (categoryId) => {
  if (categoryId === 'all') {
    return GOAL_TEMPLATES;
  }
  return GOAL_TEMPLATES.filter(template => template.category === categoryId);
};
